@if (alertFecharBanner) {
  <div class="body-alert">
    <div class="div-alert">
      <div id="test-banner-content" [innerHtml]="strBanner"></div>
      <div class="footer-alert footer w-100 h-100">
        <div class="text-center rodape">
          <button type="button" class="btn-borda-verde-claro btn-font-verde-claro ms-4 btn-grande-verde"
          (click)="fecharModal()">Fechar</button>
        </div>
      </div>
    </div>
  </div>
}